import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';

import {Dropdown, Menu} from 'antd';
import {FiMoreVertical} from 'react-icons/fi';

export const AppMenu = (props) => {
  const intl = useIntl();
  const {setEditing, setViewing} = props;

  const menu = (
    <Menu>
      <Menu.Item key='update'>
        <a onClick={() => setEditing(true)}>{intl.messages['common.update']}</a>
      </Menu.Item>
      <Menu.Item key='view'>
        <a onClick={() => setViewing(true)}>
          {intl.messages['common.viewAll']}
        </a>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <a
        className='ant-dropdown-link cr-dropdown-link'
        onClick={(e) => e.preventDefault()}>
        <FiMoreVertical />
      </a>
    </Dropdown>
  );
};

AppMenu.propTypes = {
  setEditing: PropTypes.func,
  setViewing: PropTypes.func,
};
